import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const defaultRenderFunctions = {
  button: props => {
    return /*#__PURE__*/_jsx("button", {
      type: "button",
      ...props
    });
  },
  div: props => {
    return /*#__PURE__*/_jsx("div", {
      ...props
    });
  },
  h2: props => {
    // eslint-disable-next-line jsx-a11y/heading-has-content
    return /*#__PURE__*/_jsx("h2", {
      ...props
    });
  },
  output: props => {
    return /*#__PURE__*/_jsx("output", {
      ...props
    });
  },
  p: props => {
    return /*#__PURE__*/_jsx("p", {
      ...props
    });
  },
  span: props => {
    return /*#__PURE__*/_jsx("span", {
      ...props
    });
  },
  a: props => {
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return /*#__PURE__*/_jsx("a", {
      ...props
    });
  },
  label: props => {
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    return /*#__PURE__*/_jsx("label", {
      ...props
    });
  },
  input: props => {
    return /*#__PURE__*/_jsx("input", {
      ...props
    });
  },
  fieldset: props => {
    return /*#__PURE__*/_jsx("fieldset", {
      ...props
    });
  }
};